<template>
  <base-slide-panel :isOpen="panelOpen" :large="true" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="lens"/>
          <h2 class="font-bold ml-2">Búsquedas guardadas</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div v-if="emptySearches" class="p-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1 pl-1">No hay búsquedas guardadas</label>
              <br/>
            </div>
            <div v-else>
              <base-search-item
                v-for="search in searches"
                :key="search.id"
                :id="search.id"
                :nombre="search.name"
                :tags="search.tags"
                @applySearch="applySearch"
                @deleteSearch="deleteSearch"
              />
            </div>
          </div>
          
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { LABEL_FILTROS } from '@/config/label-filtros'
import { getBusquedas } from '@/services/searches/getBusquedas'
import { deleteBusqueda } from '@/services/searches/deleteBusqueda'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    },
    vuexnamespace: {
      type: String,
      default: ''
    },
    idVista: {
      type: Number,
      default: -1
    }
  },
  data: function () {
    return {
      // vuexnamespace: 'users',
      isOpen: this.panelOpen,
      labelFiltros: LABEL_FILTROS,
      searches: [],
      // types: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    // this.types = await this.$store.getters['app/notificationsTypes']
    this.updateData()
  },
  computed: {
    emptySearches: function () {
      return this.searches === undefined || this.searches === null |this.searches.length === 0
    }
  },
  methods: {
    updateData: async function () {
    // Get búsquedas by vista
      try {
        // this.$store.commit('setIsLoading', true)
        this.searches = []
        const params = {
          IdVista: this.idVista
        }
        const response = await getBusquedas(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          setTimeout(() => {
            response.respuesta.forEach(element => {
              const search = {
                id: element.IdBusqueda,
                name: element.Nombre,
                tags: []
              }
              element.Filtros.forEach(filtro => {
                const tag = []
                tag.push(filtro.Clave)
                // console.log('filtro', filtro)
                
                tag.push(this.labelFiltros.filter(x => x.idVista.includes(this.idVista) && x.id === filtro.Clave)[0].label)
                const valor = filtro.Valor === 'true' ? true 
                  : filtro.Valor === 'false' ? false 
                    : (!isNaN(filtro.Valor) && filtro.Valor !== '060') ? parseInt(filtro.Valor) 
                      : filtro.Valor
                tag.push(valor)
                if (filtro.Clave === 'partner') {
                  const dynamicValue = this.$store.getters['app/tiposPartners'].filter(x => x.IdPartner === valor)[0].Nombre
                  tag.push(dynamicValue) 
                }  
                if (filtro.Clave === 'tipoServicio') {
                  const dynamicValue = this.$store.getters['app/tiposServicio'].filter(x => x.IdTipoServicio === valor)[0].Descripcion
                  tag.push(dynamicValue) 
                }   
                if (filtro.Clave === 'grupoVigilante') {
                  const dynamicValue = this.$store.getters['app/tiposGruposVigilantes'].filter(x => x.IdEmpresa === valor)[0].Nombre
                  tag.push(dynamicValue) 
                }
                // Filtros multiples
                const actualTag = search.tags.filter(x => x[0] === tag[0])
                if (actualTag.length > 0) {
                  if (!Array.isArray(actualTag[0][2])) {
                    const valueBeforeArray = actualTag[0][2]
                    actualTag[0][2] = []
                    actualTag[0][2].push(valueBeforeArray)
                  }
                  actualTag[0][2].push(tag[2])
                } else {
                  // Filtros objetos
                  if (filtro.Clave === 'metadato1' || 
                    filtro.Clave === 'metadato2' || 
                    filtro.Clave === 'metadato3' || 
                    filtro.Clave === 'metadato4' || 
                    filtro.Clave === 'metadato5') {
                    tag[2] = JSON.parse(tag[2])
                  }
                  search.tags.push(tag)
                }
              })
              this.searches.push(search)
              this.$emit('updateNumberSearches', this.searches.length)
            })
          }, 200)
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        // this.$store.commit('setIsLoading', false)
      }
    },
    panelOpenHandler: function (data) {
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    applySearch: function (tags) {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', tags)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    deleteSearch: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idBusqueda: id
        }
        const response = await deleteBusqueda(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.searches = this.searches.filter(x => x.id !== id)
          this.doFeedback('Búsqueda eliminada correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.$emit('updateNumberSearches', this.searches.length)
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
